import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { HeaderWithDescription } from '../../common/headerWithDescription/HeaderWithDescription';
import { ColumnLayout } from '../../common/layouts/columnLayout/ColumnLayout';
import { SpaceBetweenLayout } from '../../common/layouts/spaceBetweenLayout/SpaceBetweenLayout';
import { ICostUsageDto } from '../services/cloudCostsApi.service';
import { CloudCostsUsage } from './CloudCostsUsage';

interface IProps {
  usage: ICostUsageDto | null;
}

export const CloudCostsHeader = ({ usage }: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <SpaceBetweenLayout>
      <ColumnLayout size='md'>
        <HeaderWithDescription header={t('cloud_costs_label')} />
      </ColumnLayout>
      <ColumnLayout size='md'>
        {usage && (
          <CloudCostsUsage
            used={usage.usage}
            limit={usage.limit}
          />
        )}
      </ColumnLayout>
    </SpaceBetweenLayout>
  );
};
